import { Route } from 'react-router-dom'

import Header from 'components/Header'

import Container from './styles'

function BaseLayout({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Container>
          <Header />
          <main className="main">
            <Component {...matchProps} />
          </main>
        </Container>
      )}
    />
  )
}

export default BaseLayout
